import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import SectionCard from '../../../components/SectionCard/SectionCard';
import PieChart from '../../../components/Graphs/PieChart/PieChart';
import ProgressBar from '../../../components/Graphs/ProgressBar/ProgressBar';
import HelpIcon from '../../../components/core/HelpIcon/HelpIcon';
import { useGetApplicationsPieChartQuery } from '../../../services/endpoints/programsEndpoints';

import Tooltip from '@mui/material/Tooltip';

import StyledWrapper from '../style';
import { getStatusColor } from '../../../utils/utilFunctions';
import { getLocalAuth } from '../../../utils/environmentUtils';

const Applications = () => {
	const accountSource = useSelector((state) => state?.login?.accountSource);
	const apiToken = getLocalAuth(accountSource)?.access_token;
	let { programID } = useParams();
	programID = programID?.replace('p-', '');

	const [pieChartData, setPieChartData] = useState([]);
	const [minDate, setMinDate] = useState('');
	const [maxDate, setMaxDate] = useState('');
	const { data } = useGetApplicationsPieChartQuery(
		{ apiToken, programID },
		{ refetchOnMountOrArgChange: true }
	);

	useEffect(() => {
		if (data) {
			const chartData = [];

			data.results.forEach((application) => {
				const chartStatusIndex = chartData.findIndex((row) => row.id === application.status);

				if (chartStatusIndex === -1) {
					chartData.push({
						id: application.status,
						value: 1,
						color: getStatusColor(application.status)
					});
				} else {
					chartData[chartStatusIndex].value += 1;
				}

				const startDate = application.form_stage_id?.start_date || application.process_start_date;

				if (!minDate || new Date(minDate) > new Date(startDate)) {
					setMinDate(startDate);
				}

				const endDate = application.form_stage_id?.end_date || application.process_end_date;

				if (!maxDate || new Date(maxDate) < new Date(endDate)) {
					setMaxDate(endDate);
				}
			});

			setPieChartData(chartData);
		}
	}, [data]);

	return (
		<SectionCard minWidth={'49%'} width={'100%'} noscroll={true}>
			<StyledWrapper.CardTitleContainer data-testid={`overview-applications-title-container`}>
				<Tooltip title={`View all Program Applications`} placement="top" arrow>
					<StyledWrapper.CardTitle
						data-testid={`overview-applications-title`}
						to={`/programs/p-${programID}/applications`}
					>
						Applications ({data?.results.length || 0})
					</StyledWrapper.CardTitle>
				</Tooltip>
			</StyledWrapper.CardTitleContainer>
			{data?.results.length > 0 ? (
				<>
					<StyledWrapper.CardRowContainer width={'92%'}>
						<StyledWrapper.CardRowTitle
							data-testid={`overview-applications-row-label`}
							margin={'15px 0px 0px 0px'}
						>
							Time Remaining <HelpIcon data-testid={`overview-applications-row-icon`} />
						</StyledWrapper.CardRowTitle>
						<StyledWrapper.CardRowInfo>
							<ProgressBar
								testTitle={'overviewApplications'}
								data={{
									startDate: new Date(minDate),
									endDate: new Date(maxDate),
									isCountdown: true
								}}
							/>
						</StyledWrapper.CardRowInfo>
					</StyledWrapper.CardRowContainer>

					<StyledWrapper.ChartContainer data-testid={'nivo-pieChart'}>
						{pieChartData?.length > 0 && (
							<PieChart testTitle={'overview-applications'} data={pieChartData} />
						)}
					</StyledWrapper.ChartContainer>
				</>
			) : (
				<StyledWrapper.CardRowInfo width={'100%'} maxWidth={'100%'} align={'center'}>
					{'No Applications'}
				</StyledWrapper.CardRowInfo>
			)}
		</SectionCard>
	);
};

export default Applications;
